import { FC } from 'react';

export interface SvgCheckProps {
  size?: number;
  color?: string;
}

export const SvgCheck: FC<SvgCheckProps> = ({ size = 14, color = '#00CC88' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M20 6 9 17l-5-5" />
  </svg>
);
